module.exports = __webpack_public_path__ + "img/discount.68934266.png";